import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/dist-tag.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm dist-tag add <pkg>@<version> [<tag>]
npm dist-tag rm <pkg> <tag>
npm dist-tag ls [<pkg>]

alias: dist-tags
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/dist-tag.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`Add, remove, and enumerate distribution tags on a package:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`add: Tags the specified version of the package with the specified tag, or
the `}<inlineCode parentName="p">{`--tag`}</inlineCode>{` config if not specified. If you have two-factor
authentication on auth-and-writes then you’ll need to include a one-time
password on the command line with `}<inlineCode parentName="p">{`--otp <one-time password>`}</inlineCode>{`, or at the
OTP prompt.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`rm: Clear a tag that is no longer in use from the package. If you have
two-factor authentication on auth-and-writes then you’ll need to include
a one-time password on the command line with `}<inlineCode parentName="p">{`--otp <one-time password>`}</inlineCode>{`,
or at the OTP prompt.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ls: Show all of the dist-tags for a package, defaulting to the package in
the current prefix. This is the default action if none is specified.`}</p>
      </li>
    </ul>
    <p>{`A tag can be used when installing packages as a reference to a version instead
of using a specific version number:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install <name>@<tag>
`}</code></pre>
    <p>{`When installing dependencies, a preferred tagged version may be specified:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --tag <tag>
`}</code></pre>
    <p>{`(This also applies to any other commands that resolve and install
dependencies, such as `}<inlineCode parentName="p">{`npm dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm update`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm audit fix`}</inlineCode>{`.)`}</p>
    <p>{`Publishing a package sets the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag to the published version unless the
`}<inlineCode parentName="p">{`--tag`}</inlineCode>{` option is used. For example, `}<inlineCode parentName="p">{`npm publish --tag=beta`}</inlineCode>{`.`}</p>
    <p>{`By default, `}<inlineCode parentName="p">{`npm install <pkg>`}</inlineCode>{` (without any `}<inlineCode parentName="p">{`@<version>`}</inlineCode>{` or `}<inlineCode parentName="p">{`@<tag>`}</inlineCode>{`
specifier) installs the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag.`}</p>
    <h3>{`Purpose`}</h3>
    <p>{`Tags can be used to provide an alias instead of version numbers.`}</p>
    <p>{`For example, a project might choose to have multiple streams of development
and use a different tag for each stream, e.g., `}<inlineCode parentName="p">{`stable`}</inlineCode>{`, `}<inlineCode parentName="p">{`beta`}</inlineCode>{`, `}<inlineCode parentName="p">{`dev`}</inlineCode>{`,
`}<inlineCode parentName="p">{`canary`}</inlineCode>{`.`}</p>
    <p>{`By default, the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag is used by npm to identify the current version
of a package, and `}<inlineCode parentName="p">{`npm install <pkg>`}</inlineCode>{` (without any `}<inlineCode parentName="p">{`@<version>`}</inlineCode>{` or `}<inlineCode parentName="p">{`@<tag>`}</inlineCode>{`
specifier) installs the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag. Typically, projects only use the
`}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag for stable release versions, and use other tags for unstable
versions such as prereleases.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`next`}</inlineCode>{` tag is used by some projects to identify the upcoming version.`}</p>
    <p>{`Other than `}<inlineCode parentName="p">{`latest`}</inlineCode>{`, no tag has any special significance to npm itself.`}</p>
    <h3>{`Caveats`}</h3>
    <p>{`This command used to be known as `}<inlineCode parentName="p">{`npm tag`}</inlineCode>{`, which only created new tags,
and so had a different syntax.`}</p>
    <p>{`Tags must share a namespace with version numbers, because they are
specified in the same slot: `}<inlineCode parentName="p">{`npm install <pkg>@<version>`}</inlineCode>{` vs
`}<inlineCode parentName="p">{`npm install <pkg>@<tag>`}</inlineCode>{`.`}</p>
    <p>{`Tags that can be interpreted as valid semver ranges will be rejected. For
example, `}<inlineCode parentName="p">{`v1.4`}</inlineCode>{` cannot be used as a tag, because it is interpreted by
semver as `}<inlineCode parentName="p">{`>=1.4.0 <1.5.0`}</inlineCode>{`.  See `}<a parentName="p" {...{
        "href": "https://github.com/npm/npm/issues/6082"
      }}>{`https://github.com/npm/npm/issues/6082`}</a>{`.`}</p>
    <p>{`The simplest way to avoid semver problems with tags is to use tags that do
not begin with a number or the letter `}<inlineCode parentName="p">{`v`}</inlineCode>{`.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dedupe"
        }}>{`npm dedupe`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      